import { render, staticRenderFns } from "./CreateTicket.vue?vue&type=template&id=ff13d5dc&scoped=true&"
import script from "./CreateTicket.vue?vue&type=script&lang=js&"
export * from "./CreateTicket.vue?vue&type=script&lang=js&"
import style0 from "./CreateTicket.vue?vue&type=style&index=0&id=ff13d5dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff13d5dc",
  null
  
)

export default component.exports